var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.Store.state.loaded)?_c('div',{staticStyle:{"height":"100vh"}},[_vm._m(0)]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-body p-0 spinner-center"},[_c('div',{staticClass:"p-4 code-to-copy"},[_c('div',{staticClass:"spinner-border",attrs:{"role":"status"}})])])
}]

export { render, staticRenderFns }